'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var keymap = _interopDefault(require('../keymap/index.js'));
var index_js = require('../utils/index.js');
require('../cursor/index.js');
require('prosemirror-transform');
var prosemirrorModel = require('prosemirror-model');
var prosemirrorState = require('prosemirror-state');
var prosemirrorView = require('prosemirror-view');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

// () -> string

function uuid() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const id = [];

  for (let i = 0; i < 8; i++) {
    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
  }

  return id.join('');
}

const collapseSchema = {
  nodes: {
    collapse: {
      group: 'block',
      content: 'collapse_title collapse_content',
      isolating: true,
      allowGapCursor: true,
      dragBlock: true,
      insertBlock: true,
      braceWidth: 300,
      attrs: {
        active: {
          default: true
        },
        dataDiffId: {
          default: null
        }
      },
      parseDOM: [{
        tag: 'div[class~="ct-collapse"]',

        getAttrs(dom) {
          const dataDiffId = dom.getAttribute('data-diff-id');
          return {
            active: dom.classList.contains('active'),
            dataDiffId
          };
        }

      }],

      toDOM(node) {
        const {
          attrs: {
            active,
            dataDiffId
          }
        } = node;
        const nodeAttrs = {
          class: `ct-collapse${active ? ' active' : ''}`,
          'data-diff-id': dataDiffId || `ct-diff-id-${uuid()}`
        };
        return ['div', nodeAttrs, 0];
      }

    },
    collapse_title: {
      content: 'text*',
      draggable: false,
      isolating: true,
      alignBlock: true,
      attrs: {
        align: {
          default: 'left'
        }
      },
      parseDOM: [{
        tag: 'div[class~="ct-collapse-title"]',
        getAttrs: dom => ({
          align: dom.style.textAlign
        })
      }],

      toDOM(node) {
        const {
          align
        } = node.attrs;
        const attrs = {
          class: 'ct-collapse-title'
        };

        if (align && align !== 'left') {
          attrs.style = `text-align: ${align};`;
        }

        return ['div', attrs, ['span', {
          class: 'ct-collapse-title-text',
          spellCheck: false
        }, 0]];
      }

    },
    collapse_content: {
      content: 'block+',
      isolating: true,
      attrs: {},
      parseDOM: [{
        tag: 'div[class~="ct-collapse-content"]'
      }],

      toDOM() {
        const nodeAttrs = {
          class: 'ct-collapse-content'
        };
        return ['div', nodeAttrs, 0];
      }

    }
  }
};

function getTitleSelection(tr) {
  let titlePos;
  let addNum = 1;
  let titleSelection;

  const getTitle = function () {
    titlePos = tr.selection.$from.pos + addNum++;
    titleSelection = prosemirrorState.TextSelection.create(tr.doc, titlePos);

    if (titleSelection.$from.nodeBefore && titleSelection.$from.nodeBefore.type.name === "collapse_title") {
      titleSelection = prosemirrorState.TextSelection.create(tr.doc, titlePos - 1);
      return titleSelection;
    }

    const collapseTitle = index_js.findParentNode(titleSelection.$from.path, item => item.type && item.type.name === "collapse_title");

    if (!collapseTitle && addNum < 4) {
      // 目前最多找三次就可以找到
      return getTitle();
    }

    return titleSelection;
  };

  return getTitle();
}

function insert() {
  return function (state, dispatch, view, trigger) {
    const {
      schema
    } = state;
    const {
      collapse,
      collapse_title,
      collapse_content
    } = schema.nodes;
    const titleNode = collapse_title.createAndFill();
    const contentNode = collapse_content.createAndFill();
    const collapseNode = collapse.create(null, prosemirrorModel.Fragment.from([titleNode, contentNode]));
    const {
      transaction
    } = index_js.insertBlock(state, collapseNode);

    if (!transaction) {
      return false;
    } // 需要确定pos在collapse_title里面，否则会出现位置错误的现象


    const newSelection = getTitleSelection(transaction);
    transaction.setSelection(newSelection);
    transaction.insertText("点击展开内容", newSelection.from);
    dispatch(transaction.scrollIntoView());
    view.focus();

    if (typeof trigger === "function") {
      trigger("afterInsert", {
        draggable: true,
        braceWidth: 300
      });
    }

    return true;
  };
}

const handleClick = (view, pos, e) => {
  const isTitle = e.target.classList.contains('ct-collapse-title-text');
  const dis = e.clientX - e.target.getBoundingClientRect().left;

  if (isTitle && dis > 2 && dis < 20) {
    const {
      state,
      dispatch
    } = view;
    const {
      selection,
      tr
    } = state;
    const {
      $from
    } = selection;
    const collapse = index_js.findParentNode($from.path, item => item.type && item.type.name === 'collapse');

    if (collapse) {
      const attrs = collapse.node.attrs;
      dispatch(tr.setNodeMarkup(collapse.pos, null, objectSpread({}, attrs, {
        active: !attrs.active
      })).scrollIntoView());
    }
  }

  return false;
};

const pluginKey = new prosemirrorState.PluginKey('collapse');
function createPlugin() {
  return new prosemirrorState.Plugin({
    key: pluginKey,
    props: {
      handleClick,
      decorations: state => {
        const {
          selection
        } = state;
        const {
          $from
        } = selection;
        const collapse = index_js.findParentNode($from.path, item => item.type && item.type.name === 'collapse');

        if (collapse) {
          const attrs = {
            nodeName: 'div',
            class: 'ct-collapse-show'
          };
          const deco = prosemirrorView.Decoration.node(collapse.pos, collapse.pos + collapse.node.nodeSize, attrs);
          return prosemirrorView.DecorationSet.create(state.doc, [deco]);
        }
      },
      handleDrop: (view, event, slice, moved) => {
        try {
          const {
            status
          } = view.state.schema.nodes;

          if (event.target.classList.contains("ct-collapse")) {
            return true;
          }

          if (event.target.closest(".ct-collapse-title")) {
            const content = slice.content.content;

            if (content.length > 1) {
              return true;
            }

            if (content[0].isTextblock && content[0].content.content.length === 1) {
              return false;
            }

            if (content[0].isBlock || content[0].type === status) {
              return true;
            }
          }
        } catch (err) {}
      }
    }
  });
}

const handleBackspace = index_js.handleBackspaceCreator('collapse', 'collapse_title', 'collapse_content');
const handleDelete = index_js.handleDeleteCreator('collapse', 'collapse_title', 'collapse_content');
const handleTab = index_js.handleTabCreator('collapse', 'collapse_title', 'collapse_content');
const handleEnter = index_js.handleEnterCreator('collapse', 'collapse_title', 'collapse_content');

function handleClick$1(e) {
  const $target = e.target;
  if (!$target.closest('.ct-collapse-title')) return;
  const ctCollapse = $target.closest('.ct-collapse'); // 展开宏结构如果变动，这块代码可能需要调整

  const cls = ctCollapse.classList; // 版本比对时，不进行折叠

  if (ctCollapse.getAttribute('data-diff-ignore')) {
    return;
  } // 避免 Review 页无法点击冲突选择项


  if (!cls.contains('ct-collapse')) {
    return;
  }

  if (cls.contains('active')) {
    cls.remove('active');
  } else {
    cls.add('active');
  }

  e.stopPropagation();
  e.preventDefault();
} // 兼容旧数据


function compatiOldData(node) {
  const title = node.querySelector('.ct-collapse-title');
  const titleText = node.querySelector('.ct-collapse-title .ct-collapse-title-text');

  if (!titleText && title) {
    const newText = document.createElement('span');
    newText.className = 'ct-collapse-title-text';
    newText.innerHTML = title.innerHTML;
    const childNode = title.childNodes[0];
    childNode && title.removeChild(childNode);
    title.appendChild(newText);
  }
}

function toView({
  bodyWrapper
}) {
  const nodeList = bodyWrapper.querySelectorAll('.ct-collapse');

  if (nodeList.length) {
    nodeList.forEach(node => {
      node.addEventListener('click', handleClick$1, false);
      compatiOldData(node);
    });
  }
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ct-collapse{min-width:267px;margin:8px 0;padding:8px;border-radius:2px}.ct-collapse .ct-collapse-title{line-height:16px}.ct-collapse .ct-collapse-title>.ct-collapse-title-text{position:relative;padding-left:24px;color:#333;font-family:PingFangSC-Medium;font-size:13px;vertical-align:top}.ct-collapse .ct-collapse-title>.ct-collapse-title-text:before{position:absolute;top:2px;left:3px;content:\"\";width:16px;height:16px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M375.967 310.026L28.207 642.81a89.34 89.34 0 0 0 0 130.17 99.323 99.323 0 0 0 136.058 0l347.76-332.657 347.759 332.785a99.323 99.323 0 0 0 136.057 0 89.34 89.34 0 0 0 0-130.17l-347.76-332.784-65.916-59.39a105.723 105.723 0 0 0-140.281 0l-65.917 59.39z' fill='%23747272'/%3E%3C/svg%3E\") no-repeat 50%;-webkit-transform:rotate(-180deg);transform:rotate(-180deg);transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;cursor:pointer}.ct-collapse.active>.ct-collapse-title{padding-bottom:8px}.ct-collapse.active>.ct-collapse-title .ct-collapse-title-text:before{-webkit-transform:rotate(0deg);transform:rotate(0deg)}.ct-collapse.active>.ct-collapse-content{display:block;height:auto;padding:8px 24px;border-radius:2px}.ct-collapse>.ct-collapse-content{height:.1px;padding:0;background:transparent;overflow:hidden}.ProseMirror .ct-collapse{overflow:hidden}.ProseMirror .ct-collapse.active>.ct-collapse-content{display:block;height:auto;border-radius:2px}.ProseMirror .ct-collapse>.ct-collapse-content{display:none;overflow:unset}.ProseMirror .ct-collapse:hover{background-color:#f6f6f6}.ProseMirror .ct-collapse:hover>.ct-collapse-content{background-color:#fff}.ProseMirror .ct-collapse-show>.ct-collapse{background-color:#f6f6f6;border:1px solid #ddd}.ProseMirror .ct-collapse-show>.ct-collapse>.ct-collapse-content{background-color:#f6f6f6}.ProseMirror .ct-collapse-show>.active>.ct-collapse-content{background-color:#fff;border:1px solid #ddd}.ProseMirror-selectednode.ct-collapse{border:1px solid #1c6cdc}.pm-body-wrapper .ct-collapse-title-text{cursor:pointer}";
styleInject(css);

class CollapseModule {
  constructor() {
    this.name = 'collapse';
    this.schema = collapseSchema;
    this.commands = {
      insert
    };
    this.plugins = [createPlugin(), keymap({
      Backspace: handleBackspace,
      'Mod-Backspace': handleBackspace,
      Delete: handleDelete,
      'Mod-Delete': handleDelete,
      Tab: handleTab,
      Enter: handleEnter
    })];
  }

}
CollapseModule.moduleName = 'collapse';

exports.CollapseModule = CollapseModule;
exports.collapseToView = toView;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/collapse/index.js